<template>
  <span class="inline-svg" :class="name" v-html="url"></span>
</template>

<script>
  export default {
    props: ['name'],
    computed: {
      url () {
        return require(`../assets/svg/${this.name}.svg`)
      }
    }
  }

</script>

<style lang="scss">

  .inline-svg {
    display: inline-block;

    svg {
      display: block;
      width: 100%;
      height: 100%;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/InlineSvg.vue